import PropTypes from 'prop-types';
import { createPrefixedActionFactory } from './actionUtils';
import { DiscountUnits } from '../../../utils/constants';

const prefix = 'ORDER';
const createAction = createPrefixedActionFactory(prefix);

export const changeDeliveryFee = createAction({
  type: 'CHANGE_DELIVERY_FEE',
  propTypes: {
    deliveryFee: PropTypes.number,
  },
});

export const phoneChange = createAction({
  type: 'PHONE_CHANGE',
  propTypes: {
    phone: PropTypes.string,
  },
});

export const startOrderRequest = createAction({
  type: 'START_ORDER_REQUEST',
  propTypes: {
    phone: PropTypes.string.isRequired,
  },
});

export const startOrderSuccess = createAction({
  type: 'START_ORDER_SUCCESS',
  propTypes: {
    callerInfo: PropTypes.object,
    comments: PropTypes.array,
    commentsServerTimestamp: PropTypes.number,
  },
});

export const startOrderError = createAction({
  type: 'START_ORDER_ERROR',
  propTypes: {
    error: PropTypes.any,
  },
});

export const updateCustomer = createAction({
  type: 'UPDATE_CUSTOMER',
  propTypes: {
    customer: PropTypes.object.isRequired,
  },
});

export const fetchOrderHistory = createAction({
  type: 'FETCH_ORDER_HISTORY',
  propTypes: {
    customerId: PropTypes.string,
  },
});

export const fetchOrderHistorySuccess = createAction({
  type: 'FETCH_ORDER_HISTORY_SUCCESS',
  propTypes: {
    orders: PropTypes.array,
    displayableOrders: PropTypes.array,
  },
});

export const customerDetailsDone = createAction({
  type: 'CUSTOMER_DETAILS_DONE',
  propTypes: {},
});

export const updateDeliveryType = createAction({
  type: 'UPDATE_DELIVERY_TYPE',
  propTypes: {
    deliveryType: PropTypes.string.isRequired,
  },
});

export const updateDeliveryAddress = createAction({
  type: 'UPDATE_DELIVERY_ADDRESS',
  propTypes: {
    address: PropTypes.object.isRequired,
  },
});

export const deliveryDetailsDone = createAction({
  type: 'DELIVERY_DETAILS_DONE',
  propTypes: {},
});

export const menuQuery = createAction({
  type: 'MENU_QUERY',
  propTypes: {
    query: PropTypes.string,
  },
});

export const toggleMenuFilter = createAction({
  type: 'TOGGLE_MENU_FILTER',
  propTypes: {
    filter: PropTypes.string.isRequired,
  },
});

export const clearFilters = createAction({
  type: 'CLEAR_FILTERS',
  propTypes: {},
});

export const cartUpsert = createAction({
  type: 'CART_UPSERT',
  propTypes: {
    orderItem: PropTypes.object.isRequired,
    cartIndex: PropTypes.number.isRequired,
  },
});

export const orderItemChangeCount = createAction({
  type: 'ORDER_ITEM_CHANGE_COUNT',
  propTypes: {
    previousCount: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    cartIndex: PropTypes.number.isRequired,
  },
});

export const goToCheckout = createAction({
  type: 'GO_TO_CHECKOUT',
  propTypes: {},
});

export const cancelOrder = createAction({
  type: 'CANCEL_ORDER',
});

export const setPaymentAssociations = createAction({
  type: 'SET_PAYMENT_ASSOCIATIONS',
  propTypes: {
    paymentAssociations: PropTypes.array.isRequired,
  },
});

export const addComment = createAction({
  type: 'ADD_COMMENT',
  propTypes: {
    text: PropTypes.string,
    userId: PropTypes.string,
  },
});

export const changeOrderComment = createAction({
  type: 'CHANGE_ORDER_COMMENT',
  propTypes: {
    value: PropTypes.string,
  },
});

export const setManagerDiscount = createAction({
  type: 'SET_MANAGER_DISCOUNT',
  propTypes: {
    amount: PropTypes.number,
    unit: PropTypes.oneOf([DiscountUnits.CURRENCY, DiscountUnits.PERCENT]),
  },
});

export const resetManagerDiscount = createAction({
  type: 'RESET_MANAGER_DISCOUNT',
  propTypes: {},
});

export const setCommentsServerTimestamp = createAction({
  type: 'SET_COMMENTS_SERVER_TIMESTAMP',
  propTypes: {
    commentsServerTimestamp: PropTypes.number,
  },
});

export const setHasUnsavedComments = createAction({
  type: 'SET_HAS_UNSAVED_COMMENTS',
  propTypes: {
    hasUnsavedComments: PropTypes.bool,
  },
});

export const sendCommentsToServer = createAction({
  type: 'SEND_COMMENTS_TO_SERVER',
  propTypes: {},
});
